import { PaymentProvider, SubscriptionStatus } from "@brookbush/database";
import type {
	CancellationSurveyFormSchema,
	PayPalSubscription,
	SubscriptionExpanded,
} from "@brookbush/types";

import { useAuth } from "@clerk/nextjs";
import useSWR, { mutate as globalMutate } from "swr";

import useSubscriptionDB from "./useSubscriptionDB";
import fetcher from "~/utils/fetcher.client";

const usePayPalSubscription = () => {
	const { userId } = useAuth();

	const { subscriptionDB, refreshSubscriptionDB } = useSubscriptionDB();

	const {
		data: paypalSubscription,
		isLoading: isLoadingPayPalSubscription,
		mutate,
	} = useSWR<PayPalSubscription>(
		userId &&
			subscriptionDB?.paymentProvider === PaymentProvider.PAYPAL &&
			`/paypal/subscriptions/${subscriptionDB?.id}`,
	);

	const cancelPayPalSubscription = async (
		data: CancellationSurveyFormSchema,
	) => {
		if (!paypalSubscription) return;
		await mutate(
			fetcher(`/paypal/subscriptions/${paypalSubscription.id}`, {
				method: "DELETE",
				data: {
					surveyForm: data,
				},
			}),
			{
				revalidate: true,
				populateCache: false,
			},
		);

		globalMutate("/paypal/subscriptions");

		await refreshSubscriptionDB(
			{
				...subscriptionDB,
				status: SubscriptionStatus.CANCELED,
			} as SubscriptionExpanded,
			{
				revalidate: false,
			},
		);
	};

	return {
		paypalSubscription,
		isLoadingPayPalSubscription,
		cancelPayPalSubscription,
	};
};

export default usePayPalSubscription;
